import { ViewNetTermsCTA } from "./ctas";
export var Net60BasicsIA = function Net60BasicsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return NET_60_TERMS(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [NET_60_TERMS_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return ViewNetTermsCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _ViewNetTermsCTA$getL, _ViewNetTermsCTA;
        return (_ViewNetTermsCTA$getL = (_ViewNetTermsCTA = ViewNetTermsCTA(strictLocalize)).getLink) === null || _ViewNetTermsCTA$getL === void 0 ? void 0 : _ViewNetTermsCTA$getL.call(_ViewNetTermsCTA);
      }
    }
  };
};
var NET_60_TERMS = function NET_60_TERMS(strictLocalize) {
  return strictLocalize({
    id: "ZLwdMl",
    defaultMessage: [{
      "type": 0,
      "value": "Over een betalingstermijn van netto 60 dagen"
    }]
  });
};
var NET_60_TERMS_EXPLANATION = function NET_60_TERMS_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "DX76OY",
    defaultMessage: [{
      "type": 0,
      "value": "De betalingstermijn van netto 60 dagen is een betalingsoptie die wij aanbieden op Faire waarmee je nu nieuwe voorraad kunt inkopen en deze 60 dagen later kunt betalen. Wij bieden een betalingstermijn van netto 60 dagen aan zodat je de optimale hoeveelheid voorraad voor je winkel kunt inkopen, en tegelijkertijd je cashflow beheert. Je kunt je beschikbare termijnen bekijken door op de knop hieronder te klikken of het artikel in het Helpcentrum te lezen voor meer informatie. Neem contact met ons op als je meer hulp nodig hebt."
    }]
  });
};